import React, { FC } from 'react'

import { PaymentNotes } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { paymentAuditNotesFilterOptions } from '@new/__global/components/Filters/Filters.constants'

import { FiltersSharedProps } from './Filters.types'
import { RadioBasedField } from './FiltersVariations/Radio'

interface AuditPaymentFilterProps extends FiltersSharedProps {
  title: string
  onChange: (value?: PaymentNotes) => void
  initialValue?: PaymentNotes
}

export const AuditPaymentNotesFilter: FC<AuditPaymentFilterProps> = ({
  title,
  onChange,
  initialValue,
  isSidebarFilter,
  isAccordionOpen,
}) => {
  return (
    <RadioBasedField
      radioGroupId="auditPaymentNotesFilter"
      options={paymentAuditNotesFilterOptions}
      title={title}
      onChange={onChange}
      initialValue={initialValue}
      isSidebarFilter={isSidebarFilter}
      isAccordionOpen={isAccordionOpen}
    />
  )
}
